import merge from 'lodash/merge';

/**
 * Миксин добавления различных атрибутов к DOM-элементам
 * merge через lodash/merge — не зависит от window._ (на guest landing lodash не подключается глобально)
 */
export default {
    props: {
        pt: {
            type: Object,
            required: false,
            default: null,
        },
    },
    methods: {
        getPT(pcSection) {
            return this.pt?.[pcSection];
        },
        mergePT(base, override) {
            if (!override) {
                return base ?? {};
            }

            return merge({}, base ?? {}, override);
        },
    },
};
